export default "__VITE_ASSET__c76ca305__"